import {
  Grid,

} from '@mui/material';
import { SuppliersMenu } from '../../../components/PredefinedMenus/PredefinedMenus';
import {  useFormik } from 'formik';
import { useTranslation, getLanguage } from 'react-multi-lang';
import { MyRadioGroup } from '../../../components/radio-group/radio-group';
import { havePermission } from '../../../services/hoc/permissions';
import { Cancel, Delete, Launch } from '@mui/icons-material';
//import EditbleTable from '../../../components/editble-table';
import EditbleTable from '../../../components/editble-table/Editable_table_v1';
import GreenButton from '../../../components/buttons/green-button';
import { Save, Print } from '@mui/icons-material';
import  {
  iPurchaseBillDetail,
  iPurchaseBillResponse,


} from '../../../services/api/api';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

import { WhiteboxLoader } from '../../../components/Loader/Loader';
import { NumberToString } from '../../../services/to_wrtten_number';
import { useNotification } from '../../../services/usenotification';
import { convertDate } from '../../../services/convertDate';
import { useGetGlasses } from '../../../services/query/useGetGlasses';
import WhiteButton from '../../../components/buttons/white-button';
import { Confirm } from '../../../components/Alerts/Alerts';

import { purchaseBillSlicer } from './billSlice';
import { useDispatch } from 'react-redux';
import {
  InputField,

} from '../../../components/FormElements/FormElements';
import { AxiosError } from 'axios';
import Backbutton from '../../../components/buttons/backbutton/backbutton';
import { IconButton } from '../../../components/icon-button';
import {PrintPurchaseBill} from '../../../components/print/print_purchase_bill'
import Title from '../../../components/Title/Title';

import { useAPI } from '../../../services/hoc/useAPI';
import { CreateBillValidation } from './validation';
interface iHasFocus {
  [key: string]: boolean;
}
let paid_type= [{
  label: getLanguage() === 'en' ? 'Cash' : 'شراء نقدي',
  value: 'Cash',
},
{
  label: getLanguage() === 'en' ? 'Debt' : 'شراء اّجل',
  value: 'Post Paid',
}]
export const CreatePurchaseBill = () => {
  const t = useTranslation();
  const { alert, alertError500 } = useNotification();
   const api = useAPI()
  const navigate = useNavigate();
 
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [glasess, setGlasses] = useState<any[]>([]);
  const [hasFocus, setHasFocus] = useState<iHasFocus>({});
  const hasInitialValues = useRef<boolean>(false);
  const dispatch = useDispatch();
  
  const [blured, setBlured] = useState({ net_after_tax: false });
  const [autoFilling,setAutoFilling]=useState({field:''})
  const [disabled, setDisabled] = useState(true);
  const { getGlasses, glassesError, glassesData, glassesDataLoading } =
    useGetGlasses();
  const numbertoString = new NumberToString();
  const [formOptions, setFormOptions] = useState({ dirty: false, index: 0 });
  const [printPurchaseBill, setPrintPurchaseBill] = useState({
    open: false,
    data: {},
  });
  const formik = useFormik<
    iPurchaseBillResponse 
  >({
    initialValues: {
      bill_no: '',
      date: '',
      net_after_tax: '',
      net_after_tax_str: '',
      note: '',
      paid: '',
      remains: '',
      tax_amount: '',
      total: '',
      type: 'Cash',
      
    },
    validationSchema:CreateBillValidation
       ,
    onSubmit: () => {},
  });
  const { order_id, bill_id } = useParams();


const customHandleChange =(e:React.ChangeEvent,index:number)=>{

  type bill_key = keyof iPurchaseBillDetail
  type EditableDetail = {
  [K in keyof iPurchaseBillDetail]: any;
};
  let new_values:iPurchaseBillDetail[]|undefined= formik.values.purchasebilldetail?.map(ele=>({...ele}))
  let target = e.target as HTMLInputElement
  let match = target.name.match(/\[(\w+)\]$/)
  let _input_name = match ? match[1] : ''
 

  let new_row:EditableDetail|undefined = new_values?.[index]
  if (new_row)new_row[_input_name as bill_key]=target.value
  if (new_values){

    let new_details =  handleAutoFilling_v1(new_values,index)
    formik.setValues(pre=>({...pre,
      total:new_details.total.toString(),
      tax_amount:new_details.total_tax.toString(),
      net_after_tax:new_details.total_after_tax.toString(),
      net_after_tax_str:convertNetToString(new_details.total_after_tax.toString()),
      remains:new_details.remains.toString(),
      paid:new_details.paid.toString(),
      purchasebilldetail:new_details.purchasebilldetail

    }))
  }
    
}

  const customchangeHandler = (e: React.ChangeEvent) => {
    if (havePermission("Edit Purchase Bill")){
    let new_formOptions = { ...formOptions };
    if (bill_id) new_formOptions.dirty=true
    setFormOptions(pre=>new_formOptions);

    formik.handleChange(e);
    }
    else {
      let message= t("no_edit_permission")
      alert({en:message,ar:message},'info')
    }
  };
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    let focus = { ...hasFocus };
    focus[e.target.name] = true;
    setHasFocus(focus);
  };
  const customHandleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if ((e.target as HTMLInputElement).name === 'net_after_tax') {
      setBlured((pre) => ({ ...pre, net_after_tax: true }));
    }
    if (order_id) {
      setDisabled(false);
    }
    if (Object.keys(hasFocus).includes((e.target as HTMLInputElement).name)) {
      let focus = { ...hasFocus };
      focus[e.target.name] = false;
      setHasFocus(focus);
    }

    formik.handleBlur(e);
  };
  const handlePrint =()=>{
    if (bill_id){

      setPrintPurchaseBill(pre =>({...pre ,open:true}))
    }
    else {
     handleBill({print:true})

    }
  }

  const handleBill =  ({print=false}) => {
    formik.validateForm()
    if (Object.keys(formik.errors).length > 0) {
      let touched: { [key: string]: boolean } = {};
      Object.keys(formik.errors).map((ele) => (touched[ele] = true));
   
      formik.setTouched(touched);
      return;
    } else {
      setLoading(true);
      bill_id
        ? api
            .purchaseBill()
            .update({
              order_id: formik.values.purchase_order_id
                ? formik.values.purchase_order_id
                : 0,
              bill_no: formik.values.bill_no,
              billdetails: formik.values.purchasebilldetail?.map((ele) => ({
                area: ele.area,
                box_count: ele.box_count,
                description: ele.description,
                glass_id: ele.glass_id,
                width: ele.width,
                length: ele.length,
                price: ele.Price,
                total: ele.Total,
                tax: ele.Tax,
                purchase_order_details_id: ele.purchase_order_details_id,
                sheet_count: ele.sheet_count,
                sheet_total: ele.sheet_total,
                total_after_tax: ele.Total_after_tax,
              })),
              net_after_tax: formik.values.net_after_tax,
              net_after_tax_str: formik.values.net_after_tax_str,
              note: formik.values.note??'__',
              paid: formik.values.paid,
              remains: formik.values.remains,
              supplier_id: formik.values.supplier_id,
              tax_amount: formik.values.tax_amount,
              total: formik.values.total,
              type: formik.values.type,
              id: parseInt(bill_id),
              date: convertDate(formik.values.date ? formik.values.date : ''),
            })
            .then((res: any) => {
              setLoading(false)
              if (res.data.data && res.data.data.id) {
                dispatch(purchaseBillSlicer.actions.updateBill(res.data.data));
                setPrintPurchaseBill(pre=>({...pre ,data:res.data.data.id,open:print}))
                alert(
                  {
                    en: 'You updated bill successfully',
                    ar: 'تم تعديل الفاتورة بنجاح',
                  },
                  'success',
                );
              } else {
              
                Object.keys(res.data.data).map((ele) =>
                  alert(
                    { en: res.data.data[ele][0], ar: res.data.data[ele][0] },
                    'error',
                  ),
                );
              }
            })
            .catch((err) => {
              setLoading(false);
              alertError500(err);
            })
        : api
            .purchaseBill()
            .store({
              order_id: order_id ? parseInt(order_id) : 0,
              bill_no: formik.values.bill_no,
              billdetails: formik.values.purchasebilldetail?.map((ele) => ({
                area: ele.area,
                box_count: ele.box_count,
                description: ele.description,
                glass_id: ele.glass_id,
                width: ele.width,
                length: ele.length,
                price: ele.Price,
                total: ele.Total,
                tax: ele.Tax,
                purchase_order_details_id: ele.id,
                sheet_count: ele.sheet_count,
                sheet_total: ele.sheet_total,
                total_after_tax: ele.Total_after_tax,
              })),
              net_after_tax: formik.values.net_after_tax,
              net_after_tax_str: formik.values.net_after_tax_str,
              note: formik.values.note,
              paid: formik.values.paid,
              remains: formik.values.remains,
              supplier_id: formik.values.supplier_id,
              tax_amount: formik.values.tax_amount,
              total: formik.values.total,
              type: formik.values.type,
              date: convertDate(formik.values.date ? formik.values.date : ''),
            })
            .then((res: any) => {
              setLoading(false)
              if (
                res.data.data &&
                res.data.data.id &&
                typeof res.data.data.id === 'number'
              ) {
                dispatch(purchaseBillSlicer.actions.addBill([res.data.data]));
                if (print)setPrintPurchaseBill(pre=>({...pre ,open:print}))
                alert(
                  {
                    en: 'You added bill successfully',
                    ar: 'تم اضافة الفاتورة بنجاح',
                  },
                  'success',
                );

                navigate(`/purchase-bills/${res.data.data.id}`);
              } else {
                Object.keys(res.data.data).map((ele) =>
                  alert(
                    { en: res.data.data[ele][0], ar: res.data.data[ele][0] },
                    'error',
                  ),
                );
              }
            })
            .catch((err) => {
              setLoading(false);
              alertError500(err);
            });
    }
  };

  const removeBill = () => {
    if (bill_id) {
      api
        .purchaseBill()
        .delete({ ids: [parseInt(bill_id)] })
        .then((res: any) => {
          alert(
            { en: 'your deletion is successfull', ar: 'تم الحذف بنجاح' },
            'success',
          );
          navigate('/purchase-bills');
        })
        .catch((err: any) => {
          alertError500(err);
        });
    }
  };
  const convertNetToString=(value:string):string=>{
    
    let net_after_tax_str = numbertoString.NumToStr(
      value,
    );
    return net_after_tax_str
  }


  // const deleteItem = () => {
  //   Confirm({
  //     message: t('delete_confirmation'),
  //     onConfirm: () => removeBill(),
  //   });
  // };

  useEffect(() => {
    getGlasses(1);
  }, []);

  useEffect(() => {
    if (!glassesError) {
      if (glassesData && glassesData.length > 0) {
        let data = glassesData.map((ele) => ({ ...ele, value: ele.id }));
        setGlasses(data);
      }
    }
  }, [glassesDataLoading]);

  useEffect(() => {
    if (blured && formik.values.net_after_tax) {
      let net_after_tax_str = numbertoString.NumToStr(
        formik.values.net_after_tax,
      );
      formik.setFieldValue('net_after_tax_str', net_after_tax_str);
    }
  }, [blured]);
  
  useEffect(() => {
    if (order_id) {
      setFetching(true);
      api
        .purchaseOrder()
        .show({ id: parseInt(order_id) })
        .then((res) => {
          setFetching(false);
          if (res.data && res.data.data) {
            let detials_data:iPurchaseBillDetail[] = res.data.data.purchaseorderdetail

         //console.log('deails_data',detials_data)

            let{paid,total,total_after_tax,total_tax  } =update_total(detials_data)
             let obj = {
              ...formik.values,
              ...res.data.data,
              total,
              total_after_tax,
              total_tax,
              paid,

              purchasebilldetail: detials_data,
              net_after_tax_str: numbertoString.NumToStr(
                res.data.data.net_after_tax,
              ),
            };
            hasInitialValues.current = true;
            formik.resetForm({ values: obj });
          }
        })
        .catch((err) => {
          setFetching(false);
          alertError500(err);
        });
    }
  }, [order_id]);

  useEffect(() => {
    if (bill_id) {
      setFetching(true);
      api
        .purchaseBill()
        .show({ id: parseInt(bill_id) })
        .then((res: any) => {
          setFetching(false);
          if (res.data.data) {
            hasInitialValues.current = true;
            formik.resetForm({
              values: {
                ...res.data.data,
                billdetails: res.data.data.purchasebilldetail,
              },
            }
           
            );
            setAutoFilling(pre=>({...pre,field:'start_for_all'}))
          }
        })
        .catch((err: any) => alertError500(err));
    }
  }, [bill_id]);

  const remove = () => {
    let ids =bill_id? [parseInt(bill_id)] :[]
    setFetching(true)
   
    if(ids.length>0){
     api.purchaseBill()
       .delete({ ids })
       .then(() => {
      setFetching(false)
         alert({en:'your deletion was succefull',ar:'تم الحذف بنجاح'},"success")
         navigate('/orders')
         dispatch(purchaseBillSlicer.actions.deleteBill(ids))
         
         //dispatch(purchaseOrdersSlice.actions.deleteMaterials(ids));
       }).
       catch((err:AxiosError)=>
       {
        setFetching(false)
        
        alertError500(err)
       }
      )
    }
  };

  // const handleAutoFilling=()=>{
  //   if (formik.values.billdetails && formik.values.billdetails.length>0){
    
  //   let   billdetails_changed=false
  //     let new_billdetails=[...formik.values.billdetails]
  //     let target_row= new_billdetails[formOptions.index]

  //     if (target_row && 
  //       Boolean(target_row.length) 
  //       && Boolean(target_row.width) 
  //       && target_row.length && target_row.width){
  //       billdetails_changed=true
  //       target_row.area= ((parseInt(target_row.length) * parseInt(target_row.width))/10000).toString()
  //       new_billdetails[formOptions.index]=target_row
        
  //     }
  //     if (target_row &&
  //        Boolean (target_row.box_count) 
  //        && Boolean(target_row.sheet_count) 
  //        && target_row.sheet_count && target_row.box_count) {
  //       billdetails_changed=true
  //       target_row.sheet_total=(parseInt(target_row.sheet_count) * parseInt(target_row.box_count)).toString()
  //     }
  //     if (target_row &&
  //        Boolean (target_row.Price) 
  //        && Boolean(target_row.sheet_total) 
  //        && Boolean(target_row.area)
  //        ) {
  //       billdetails_changed=true
  //       target_row.Total=(parseInt(target_row.Price) * parseInt(target_row.sheet_total) * parseInt(target_row.area)).toString()
  //     }
  //     if (target_row && 
  //       Boolean (target_row.Total) 
  //       && Boolean(target_row.Tax) 
  //       && target_row.Total && target_row.Tax) {
  //       billdetails_changed=true
  //       target_row.Total_after_tax=(parseInt(target_row.Total) + parseInt(target_row.Tax)).toString()
  //     }
  //     if (billdetails_changed) {
  //       let totall ='0'
  //       let tax='0'
  //       let totall_after_tax= '0'
  //       let paid='0'
  //       let remains='0'

  //       new_billdetails.map((ele)=> {
  //         totall = (parseInt(ele.Total) + parseInt(totall)).toString()
  //         tax=(parseInt(ele.Tax) + parseInt(tax)).toString()
  //         totall_after_tax=(parseInt(ele.Total_after_tax) + parseInt(totall_after_tax)).toString()
  //         paid=formik.values.type==='Cash'? totall_after_tax:'0'
  //         remains=formik.values.type==='Cash'?'0':totall_after_tax
        
  //       })
  //       formik.setValues(pre=>({...pre,
  //         total:totall,tax_amount:tax
  //         ,net_after_tax:totall_after_tax
  //         ,net_after_tax_str:convertNetToString(totall_after_tax)
  //         ,paid
  //         ,billdetails:new_billdetails
  //         ,remains

  //       }))
  //     }
  //   }
  // }

  const calculate_area= (length?:number,width?:number)=> length && width?((length * width)/10000).toFixed(2):0
  const calculate_total_sheets= (box_count?:number,sheet_count?:number)=> box_count&& sheet_count? box_count* sheet_count:0
  const calculate_total=(price?:number,sheet_total?:number,area?:number)=> price&&sheet_total&&area?price*sheet_total*area:0
  const calculate_total_after_tax=(total?:number,tax?:number)=> (total??0)+(tax??0)
  const update_total = (values:iPurchaseBillDetail[])=>{

     let total_obj=values.reduce((acc,curr)=>
            {
              acc['total'] = acc['total'] + parseFloat(curr.Total??'0')
              acc['total_tax']=acc['total_tax']+ parseFloat(curr.Tax??'0')
              acc['total_after_tax']=acc['total_after_tax']+ parseFloat(curr.Total_after_tax??'0')
              return acc
            }
            ,
            {total:0,total_tax:0,total_after_tax:0})
           
            let paid=formik.values.type==='Cash'? total_obj.total:formik.values.paid??'0'
            let remains=formik.values.type==='Cash'?'0':total_obj.total_after_tax
            return {paid,remains,...total_obj}
  }
  const handleAutoFilling_v1=(values:iPurchaseBillDetail[],index:number)=>{
  
      let new_values = values.map(ele=>ele)
      let target_row=new_values[index]

      if (target_row.length || target_row.width){
      
        target_row.area= calculate_area(parseInt(target_row.length??'0'),parseInt(target_row.width??'0')).toString()
       
        
      }
      if ( target_row.sheet_count || target_row.box_count ) {
      
        target_row.sheet_total=calculate_total_sheets(parseInt(target_row.box_count??'0'),parseInt(target_row.sheet_count??'0')).toString()
      }
      if (
         Boolean (target_row.Price) 
         || Boolean(target_row.sheet_total) 
         || Boolean(target_row.area)
         ) {
      
        target_row.Total=calculate_total(parseInt(target_row.Price??'0'), parseInt(target_row.sheet_total??'0'), parseInt(target_row.area??'0')).toString()
      }
      if (
    
        target_row.Total || target_row.Tax) {

        target_row.Total_after_tax=calculate_total_after_tax(parseInt(target_row.Total??'0') , parseInt(target_row.Tax??'0')).toString()
      }
       
       let {paid,remains,total,total_after_tax,total_tax} =update_total(new_values)

      
      
      return {paid,remains,total,total_after_tax,total_tax,purchasebilldetail:new_values}
    }
  

//   useEffect(()=>{
//     handleAutoFilling_v1()
// },[autoFilling])

// useEffect(()=>{

// if (!fetching &&    hasInitialValues.current && formik.values.billdetails&&formik.values.billdetails?.length>0  ){
//   let new_billdetails=[...formik.values.billdetails]
//   let totall ='0'
//   let tax='0'
//   let totall_after_tax= '0'
//   let paid='0'
//   new_billdetails.map((ele)=> {
//     totall = (parseInt(ele.Total) + parseInt(totall)).toString()
//     tax=(parseInt(ele.Tax) + parseInt(tax)).toString()
//     totall_after_tax=(parseInt(ele.Total_after_tax) + parseInt(totall_after_tax)).toString()
//     paid=formik.values.type==='Cash'? totall:formik.values.paid??'0'
//   })
//   formik.setValues(pre=>({...pre,total:totall,tax_amount:tax
//     ,net_after_tax:totall_after_tax
//     ,net_after_tax_str:convertNetToString(totall_after_tax)
//     ,paid
//     ,billdetails:new_billdetails}))
// }
// },[fetching])
// useEffect(()=>{

// if (!fetching &&    hasInitialValues.current && formik.values.purchasebilldetail&&formik.values.purchasebilldetail?.length>0  ){
//   let new_billdetails=[...formik.values.purchasebilldetail]
//   let totall ='0'
//   let tax='0'
//   let totall_after_tax= '0'
//   let paid='0'
//   new_billdetails.map((ele)=> {
//     totall = (parseInt(ele.Total) + parseInt(totall)).toString()
//     tax=(parseInt(ele.Tax) + parseInt(tax)).toString()
//     totall_after_tax=(parseInt(ele.Total_after_tax) + parseInt(totall_after_tax)).toString()
//     paid=formik.values.type==='Cash'? totall:formik.values.paid??'0'
//   })
//   formik.setValues(pre=>({...pre,total:totall,tax_amount:tax
//     ,net_after_tax:totall_after_tax
//     ,net_after_tax_str:convertNetToString(totall_after_tax)
//     ,paid
//     ,billdetails:new_billdetails}))
// }
// },[fetching])

  useEffect(() => {
    if (
      hasInitialValues.current &&
      !hasFocus['net_after_tax'] &&
      !hasFocus['paid']
    ) {
      if (formik.values.type !== 'Cash'){
      let remains = parseInt(Boolean(formik.values.net_after_tax)?formik.values.net_after_tax??'0':'0')
      -parseInt(Boolean(formik.values.paid)?formik.values.paid??'0':'0')
    
      formik.setValues((pre:any)=>({...pre , remains}))
  
      }
      else{
        let value = Boolean(formik.values.net_after_tax)?formik.values.net_after_tax:
        Boolean(formik.values.paid )?
        formik.values.paid:''
       if (Boolean(value)) formik.setValues((pre:any)=>({...pre , remains:0,paid:value,net_after_tax:value}))
      }
    }
  }, [hasFocus['paid'], hasFocus['net_after_tax']]);
  useEffect(()=>{
    if (formik.values.type!== 'Cash') {
      formik.setValues((pre:any)=>({...pre 
        ,paid:'0'
        ,remains:formik.values.net_after_tax
      }))
     
    }
  else {
    if (formik.values.net_after_tax || formik.values.paid){
    let value = formik.values.net_after_tax??formik.values.paid 
    formik.setValues((pre:any)=>({...pre , remains:0,paid:value,net_after_tax:value}))}
  }

  },[formik.values.type])

 let units: { [key: string]: string } = {}
 let key2=t('length')
 let key3=t('width')
 let key4= t('total_area')
 let key9 = t('price_in_m')
 units[key2]=`(${t("cm")})`
 units[key3]=`(${t("cm")})`
units[key4] = `(${t('m')}²)`
  units[key9] = `(${t('m')}²)`


//console.log ('values',formik.values)
//console.log('errors',formik.errors)
  if (fetching) {
    return <WhiteboxLoader />;
  }
  return (
    <Grid container padding={4} rowGap={2}>
      <Grid
      container
      size={12}
        rowGap={1}
        sx={{columnGap:{sm:2,xs:0}}}
        justifyContent={'center'}>
            {/* <Grid container justifyContent={'flex-end'} size={12} >

               <Backbutton previousPageRoute="/purchase-bills" />
            </Grid> */}
             <Title title={t("purchase_bill_details")} backbutton_path='/purchase-bills' />
          
          <Grid container justifyContent="center" size={12}>
          <IconButton
              DoIcon={<Launch sx={{color:'var(--primary-color)'}}/>}
              cancelTitle=''
              doTitle={t("show_order")}
              value={false}

             style={{margin:'0 5px'}}
              doFunction={()=>{
               {
                navigate(`/add-purchase-order/${formik.values?.purchase_order_id}`);
                return true
               }
              }}
               />
               <IconButton
              value={false}
              doTitle={t('print_invoice')}
             disabled={loading || !havePermission("Print Purchase Bill")}
              cancelTitle={t('cancel_invoice_issued')}
              doFunction={() => {
                 handlePrint()
                  return true;
                }
              }
              DoIcon={<Print style={{ color: 'var(--primary-color)' }} />}
            />
          </Grid>
        

        <Grid  size={{xs:12,sm:3}}>
          <SuppliersMenu
            placeholder={t('select_supplier') + ' *'}
            onChange={(selected: { value: number; label: string }) => {
              setFormOptions(pre=>({...pre,dirty:true}));
              formik.setFieldValue('supplier', {
                supplier_id: selected.value,
                supplier_name: selected.label,
              });
            }}
            value={
              !order_id
                ? formik.values.supplier
                  ? {
                      value: formik.values.supplier.id,
                      label: formik.values.supplier.name,
                    }
                  : null
                : {
                    value: formik.values?.supplier?.id,
                    label: formik.values?.supplier?.name,
                  }
            }
          />
        </Grid>
        <Grid size ={{sm:3,xs:12}} >
          <InputField
            name="bill_no"
            label={t('bill_no')}
            value={formik.values.bill_no}
            onChange={customchangeHandler}
            onBlur={customHandleBlur}
            error={
              Boolean(formik.errors.bill_no) && formik.touched.bill_no
                ? formik.errors.bill_no
                : ''
            }
            onFocus={handleFocus}
          />
        </Grid>
        <Grid  size ={{sm:3,xs:12}}>
          <InputField
            name={'date'}
            label={getLanguage() === 'en' ? 'Date' : 'تاريخ'}
            value={formik.values.date}
            error={
              Boolean(formik.errors.date) && formik.touched.date
                ? formik.errors.date
                : ''
            }
            onBlur={customHandleBlur}
            disabled={!havePermission('Edit Bill')}
            onChange={formik.handleChange}
            onFocus={handleFocus}
          />
        </Grid>
       
        <Grid  size ={{sm:3,xs:12}}>
          <InputField
            name="total"
            label={getLanguage() === 'en' ? 'Totall' : 'اجمالي'}
            value={formik.values.total}
            error={
              Boolean(formik.errors.total) && formik.touched.total
                ? formik.errors.total
                : ''
            }
            onBlur={customHandleBlur}
            onChange={customchangeHandler}
            disabled={true}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid  size ={{sm:3,xs:12}}>
          <InputField
            name="tax_amount"
            label={getLanguage() === 'en' ? 'Tax' : 'الضريبة'}
            value={formik.values.tax_amount}
            type="number"
            error={
              Boolean(formik.errors.tax_amount) && formik.touched.tax_amount
                ? formik.errors.tax_amount
                : ''
            }
            onBlur={customHandleBlur}
            disabled={true}
            onChange={customchangeHandler}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid  size ={{sm:3,xs:12}}>
          <InputField
            name="net_after_tax"
            label={getLanguage() === 'en' ? 'Total Bill' : 'اجمالي الفاتورة'}
            value={formik.values.net_after_tax}
            type="number"
            onChange={formik.handleChange}
            onBlur={customHandleBlur}
            error={
              Boolean(formik.errors.net_after_tax) &&
              formik.touched.net_after_tax
                ? formik.errors.net_after_tax
                : ''
            }
            disabled={true}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid  size ={{sm:3,xs:12}}>
          <InputField
            name="paid"
            label={getLanguage() === 'en' ? 'Paid' : 'المدفوع'}
            value={formik.values.paid}
            type="number"
            error={
              Boolean(formik.errors.paid) && formik.touched.paid
                ? formik.errors.paid
                : ''
            }
            onBlur={customHandleBlur}
            disabled={true}
            onChange={customchangeHandler}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid  size ={{sm:3,xs:12}}>
          <InputField
            name="remains"
            label={getLanguage() === 'en' ? 'Remain' : 'الباقي'}
            value={formik.values.remains}
            error={
              Boolean(formik.errors.remains) && formik.touched.remains
                ? formik.errors.remains
                : ''
            }
            onBlur={customHandleBlur}
            disabled={true}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid  size ={{sm:3,xs:12}}>
          <InputField
           onBlur={customHandleBlur}
            name="net_after_tax_str"
            label={
              getLanguage() === 'en'
                ? 'Totall writin Bill'
                : 'اجمالي الفاتورة كتابة'
            }
            value={formik.values.net_after_tax_str}
            type="text"
            disabled={!havePermission('Edit Bill')}
            onFocus={handleFocus}
          />
        </Grid>
        <Grid  size={{sm:3,xs:12}} >
          <MyRadioGroup
            name="type"
            onChange={customchangeHandler}
            disabled={!havePermission('Edit Bill')}
            data={paid_type}
            title=""
            value={
              formik.values.type??'Cash' 
            }
            
          />
        </Grid>
      
     
        
       
       
        
       
        <Grid size={{sm:6,xs:12}} >
          <InputField
            rows={3}
            minRows={3}
            multiline={true}
            name="note"
            label={t('note')}
            value={formik.values.note}
            onChange={customchangeHandler}
            onFocus={handleFocus}
          />
        </Grid>
      </Grid>
      <Grid size={12}>
        {/* <EditbleTable
        lines_number={formik.values.billdetails?formik.values.billdetails.length:0}
          handleChange={customHandleChange}
          handleBlur={formik.handleBlur}
          error={formik.errors.billdetails}
          no_actions={true}
          values={formik.values.billdetails?.map((ele) => ({
                glass_id: ele.glass_id,
              
                length: ele.length,
                width: ele.width,
            
                area: ele.area,
                sheet_count: ele.sheet_count,
                box_count: ele.box_count,
                sheet_total: ele.sheet_total,
                description: ele.description,
            
                Price: ele.Price,
                Total: ele.Total,
                Tax: ele.Tax,
                Total_after_tax: ele.Total_after_tax,
              
              }))}
          touched={formik.touched}
          selectInput={['glass_id']}
          headers={[
            getLanguage() === 'en' ? 'Category' : 'الصنف',
            getLanguage() === 'en' ? 'Length'+' CM' : 'الطول' +' سم',
            getLanguage() === 'en' ? 'Width' +' CM' : 'العرض' +' سم',
            getLanguage() === 'en' ? <span>Totall Area M<sup>2</sup></span> : <span> المساحة الاجمالية م<sup>2</sup></span>,
            getLanguage() === 'en' ? 'Cheaques Number' : 'عدد الألواح',
            getLanguage() === 'en' ? 'Boxes Number' : 'عدد الصناديق',
            getLanguage() === 'en' ? 'Totall Cheaques' : 'اجمالي الألواح',
            getLanguage() === 'en' ? 'Description' : 'البيان',
    
            getLanguage() === 'en' ? <span>Price in M<sup>2</sup></span> : <span>السعر في <sup>2</sup>م</span>,
            getLanguage() === 'en' ? 'Totall' : 'اجمالي',
            getLanguage() === 'en' ? 'Tax' : 'الضريبة',

            getLanguage() === 'en' ? 'Totall after Tax' : 'اجمالي بعد الضريبة',
          
           
           
          ]}
          options={{ glass_id: glasess }}
          addLine={undefined}
          removeLine={undefined}
          array_name="billdetails"
        /> */}
        <EditbleTable


    lines_number={formik.values.purchasebilldetail?formik.values.purchasebilldetail.length:0}
          handleChange={customHandleChange}
          handleBlur={formik.handleBlur}
          error={formik.errors}
         array_name='billdetails'
          values={(()=>{
            let obj: { [key: number]: iPurchaseBillDetail } = {};
            formik.values.purchasebilldetail?.map((ele,index) => (
            
             obj[index]=
              {
                glass_id: ele.glass_id,  
                length: ele.length,
                width: ele.width,
                area: ele.area,
                sheet_count: ele.sheet_count,
                box_count: ele.box_count,
                sheet_total: ele.sheet_total,
                description: ele.description,
                Price: ele.Price,
                Total: ele.Total,
                Tax: ele.Tax,
                Total_after_tax: ele.Total_after_tax,
              
              }
              
            ))
            return obj ;
            })()
            }
          touched={formik.touched}
          selectInput={['glass_id']}
          headers={[
           t('category'),
           t('length'),
            t('width'),
           t('total_area'),
            t('sheets_number'),
           t('boxes_number'),
           t('total_sheets'),
           t('description'),
          t('price_in_m'),
           t('total'),
           t('tax'),
            t('total_after_tax'),
           
          ]}
          options={{ glass_id: glasess }}
          addLine={undefined}
          removeLine={undefined}
          units={units}

         />
      </Grid>
      <Grid  container justifyContent={'center'} size={12}>
        <Grid container size ={{  sm:6,  xs:12}} justifyContent={'center'}>
          <Grid  size ={{md:3}}  sx={{marginX:{sm:1,xs:0}}}>
            <GreenButton
              label={t('save')}
              fun={() => handleBill({print:false})}
              
              fullWidth={true}
              disabled={loading || ( havePermission("Edit Purchase Bill")? (!formik.dirty || !formik.isValid)?true :false :true)}>
              <Save sx={{ color: 'white' }} />
            </GreenButton>
          </Grid>
          <Grid size={{ md:3}}  mx={1}>
            {order_id ? (
              <WhiteButton
                fullWidth={true}
                label={t('cancel')}
                fun={() => navigate('/purchase-orders')}
              >
                <Cancel sx={{color:'red'}} />
                </WhiteButton>
            ) : (
              <WhiteButton
                fullWidth={true}
                label={t('cancel')}
                fun={() =>navigate('/purchase-bills')}>
              <Cancel sx={{color:'red'}} />
              </WhiteButton>
            )}
          </Grid>
          {bill_id &&(
            <Grid size={{sm:6,xs:12,md:3}}  mx={1}>
          
              <WhiteButton
                fullWidth={true}
                disabled={!havePermission("Delete Purchase Bill")}
                label={t('delete')}
                fun={()=>  Confirm({
                  message: t('delete_confirmation'),
                  onConfirm: () => remove(),
                })}
              >
                <Delete sx={{color:'red'}} />
              </WhiteButton>
          </Grid>
          )}
        </Grid>
      </Grid>
      <div
        id="includeMe"
        style={{ position: 'absolute', visibility: 'hidden', zIndex: -1 }}>
        {printPurchaseBill.open && (
          <PrintPurchaseBill
            close={() =>
              setPrintPurchaseBill((pre) => ({ ...pre, open: false }))
            }
            data={bill_id?bill_id:printPurchaseBill.data}
          />
        )}
        
      </div>
    </Grid>
  );
};
